function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.4808 0.800781H1.52078C1.12078 0.800781 0.800781 1.12078 0.800781 1.52078V14.4808C0.800781 14.8008 1.12078 15.2008 1.52078 15.2008H14.4808C14.8008 15.2008 15.2008 14.8008 15.2008 14.4808V1.52078C15.2008 1.12078 14.8008 0.800781 14.4808 0.800781ZM5.602 4.00126H4.002V5.60126H5.602V4.00126ZM11.9999 4.00126H7.19986V5.60126H11.9999V4.00126ZM11.9999 7.20048H7.19986V8.80048H11.9999V7.20048ZM7.19986 10.401H11.9999V12.001H7.19986V10.401ZM4.002 7.20048H5.602V8.80048H4.002V7.20048ZM5.602 10.401H4.002V12.001H5.602V10.401ZM2.39887 13.6006H13.5989V2.40055H2.39887V13.6006Z"
});

var SvgListAltNew = function SvgListAltNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgListAltNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/list_alt_new.1e388083.svg";
export { ForwardRef as ReactComponent };